import { SimpleBars } from '../../../Common/Charts/SimpleBars';
import { useIDCRASChartsDataContext } from './hooks/useIDCRASChartsDataContext';

export const SizeEvolutionChart = () => {
    const { chartData } = useIDCRASChartsDataContext();

    const sizeMap = {
        '1': 'Pequeno I',
    };

    const groupedData = chartData.size.reduce((acc, item) => {
        const normalizedSize =
            sizeMap[item.porte] ||
            item.porte ||
            'Não informado';

        if (!acc[normalizedSize]) {
            acc[normalizedSize] = 0;
        }

        acc[normalizedSize] += 1;

        return acc;
    }, {});

    return (
        <SimpleBars
            title="Distribuição dos Portes"
            horizontal={true}
            subtitles={Object.keys(groupedData)}
            values={Object.values(groupedData)}
        />
    );
};